import {WinLinesPresentationView} from 'src/winlinespresentation/WinLinesPresentationView';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {GameViews} from 'src/GameViews';

export class WinLinesPresentationModule extends Module<WinLinesPresentationView>{
	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		this.setView(GameViews.WIN_LINES_PRESENTATION_VIEW);
	}

}



// WEBPACK FOOTER //
// ./src/winlinespresentation/WinLinesPresentationModule.ts